export const PORTAL_DATA = 'rpb2b-react/model/updateSamsungOrderInvoiceData';
export type PORTAL_DATA = typeof PORTAL_DATA;

export const RESULT_DATA = 'rpb2b-react/model/samsungOrderInvoiceResultData';
export type RESULT_DATA = typeof RESULT_DATA;

export const SET_IS_PENDING = 'rpb2b-react/model/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_PAGE_INFO = 'rpb2b-react/model/samsungPage/info';
export type SET_PAGE_INFO = typeof SET_PAGE_INFO;

export const SET_SAMSUNG_SEARCH_FORM = 'rpb2b-react/model/samsungForm/update';
export type SET_SAMSUNG_SEARCH_FORM = typeof SET_SAMSUNG_SEARCH_FORM;

export default {
  PORTAL_DATA,
  RESULT_DATA,
  SET_IS_PENDING,
  SET_PAGE_INFO,
  SET_SAMSUNG_SEARCH_FORM
};
